import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { getLatestArticles } from '@/mocks/articles';
import { brandInfo } from '@/mocks/brand';
import { Link } from 'react-router-dom';

const latestArticles = getLatestArticles(6);

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20luxurious%20and%20elegant%20entertainment%20platform%20concept%2C%20warm%20golden%20ambient%20lighting%2C%20abstract%20geometric%20patterns%20with%20flowing%20curves%2C%20premium%20dark%20background%20with%20golden%20accents%2C%20sophisticated%20and%20trustworthy%20atmosphere%2C%20minimalist%20composition&width=1920&height=1080&seq=hero-leyu-01&orientation=landscape"
        alt="乐鱼官网 - 官方正版入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-3xl w-full">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
            <i className="ri-shield-check-line text-primary-400 text-sm"></i>
            <span className="text-primary-300 text-xs md:text-sm font-medium">官方认证 · 安全可信赖</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            乐鱼官网
            <span className="block text-primary-400 mt-2">官方正版入口，安全可信赖</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/70 mb-8 max-w-2xl mx-auto leading-relaxed">
            乐鱼官网是您值得信赖的官方平台，提供安全、稳定、流畅的用户体验。访问乐鱼官网，享受丰富的娱乐内容与专业服务，官方认证入口，保障您的账户安全与权益。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              立即进入官网
            </Link>
            <Link
              to="/category/tiyu"
              className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap"
            >
              探索精彩内容
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩内容分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            涵盖体育赛事、电子竞技、娱乐天地等多个领域，满足您的多元化需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-2xl p-5 md:p-6 flex flex-col items-center text-center transition-all hover:bg-primary-50 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-background-50 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-all">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500 group-hover:text-background-50 transition-all`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择乐鱼官网
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            官方认证平台，以安全、稳定、专业的服务赢得千万用户的信赖
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {brandInfo.values.map((value, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${value.icon} text-2xl md:text-3xl text-accent-500`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AchievementsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {brandInfo.achievements.map((achievement, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-2">
                {achievement.number}
              </div>
              <div className="text-sm md:text-base text-background-50/80 font-medium">
                {achievement.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticlesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新资讯
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              掌握最新行业动态与平台资讯
            </p>
          </div>
          <Link
            to="/category/tiyu"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden transition-all hover:bg-background-200/70 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          立即访问乐鱼官网，开启精彩体验
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          官方认证入口，保障您的账户安全与权益。丰富的娱乐内容与专业服务等您来体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium border border-primary-300 text-primary-600 hover:bg-primary-50 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '乐鱼官网 - 官方正版入口',
          description: '乐鱼官网是您值得信赖的官方平台，提供安全、稳定、流畅的用户体验。',
          url: 'https://www.leyu.com',
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedSection />
          <AchievementsSection />
          <ArticlesSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}